import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3"
}

import {GroupByInterface} from "~/cabinet/vue/client/dashboard/Interface";
import {computed} from "vue";
import Dictionary from "~/ts/library/Dictionary";
import ObjectHelper from "~/ts/library/ObjectHelper";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "GroupByConfig"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    groupBy: {},
    limit: {},
    groupByList: {}
  },
  emits: ["update:group-by", "update:limit"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


let list = computed(() => {
    let result: Dictionary<{ groupDescr: string, groupByList: GroupByInterface[], isOther: boolean }> = {};
    for (let groupBy of props.groupByList) {
        if (!result[groupBy.groupDescr]) {
            result[groupBy.groupDescr] = {
                groupDescr: groupBy.groupDescr,
                isOther: !!groupBy.groupDescr,
                groupByList: []
            };
        }
        result[groupBy.groupDescr].groupByList.push(groupBy);
    }

    return ObjectHelper.arrayFromDictionary(result)
        .sort((a, b) => {
            if (a.isOther) {
                return 1;
            }
            if (b.isOther) {
                return -1;
            }
            return 0;
        });
});


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, { label: "Разбить данные по" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_select, {
        "model-value": _unref(props).groupBy,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:group-by', $event))),
        multiple: "",
        placeholder: "Не разбивать",
        class: "w-100"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (group) => {
            return (_openBlock(), _createBlock(_component_el_option_group, {
              key: group.groupDescr,
              label: group.groupDescr ? group.groupDescr : (__props.groupByList.length == 1 ? null : 'Другое')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.groupByList, (groupBy) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: groupBy.id,
                    value: groupBy.id,
                    label: groupBy.descr
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value"]),
      ( _unref(props).groupBy.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", null, "Максимальное количество значений", -1)),
            _createVNode(_component_el_slider, {
              "model-value": _unref(props).limit,
              min: 2,
              max: 100,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(emits)('update:limit', $event)))
            }, null, 8, ["model-value"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})